export const GET_TICKET = "GET_TICKET";
export const CLEAR_STORE = "CLEAR_STORE";
export const APPEAL_CREATED = "APPEAL_CREATED";
export const SET_LOADER = "SET_LOADER";
